import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AddReviewDto {
  @Field(t => Int)
  claimId!: number

  @Field()
  title!: string

  @Field()
  review!: string

  @Field()
  privateFeedback!: string

  @Field()
  disclaimer!: string

  @Field(t => Int)
  rating!: number

  public constructor (data: AddReviewDto) {
    Object.assign(this, data)
  }
}
